module.exports = __webpack_public_path__ + "static/media/properties.20a3e504.svg";